import * as React from 'react';
import { KonkurrenceJumbotron } from '../../konkurrence/KonkurrenceJumbotron';
import OpgaveCard from '../../konkurrence/OpgaveCard';
import { Row } from '../../../uiComponents/bootstrap-components/BootstrapComponents';
import { Jumbotron } from '../../../uiComponents/Jumbotron';
import * as moment from 'moment';
import { getLoggedInBruger, erKonkurrenceDag } from '../../../infrastructure/Security';
import bedoemmesAfTilRolleMap from '../../../models/mappers/BedoemmesAfTilRolleMap';
import { KonkurrenceOpgave } from '../../../models/KonkurrenceOpgave';
import { Opgavepakke } from '../../../models/Opgavepakke';
import { KonkurrenceAfviklingssted } from '../../../models/KonkurrenceAfviklingssted';

export interface KonkurrenceOverblikEksternPresenterProps {
    konkurrencetitel: string;
    konkurrenceDate: Date;
    konkurrenceAfviklingssted: KonkurrenceAfviklingssted;
    konkurrenceId: string;
    billedId: string;
    beskrivelse: string;
    opgavepakker: Opgavepakke[];
    opgaver: KonkurrenceOpgave[];
    opgaverSynligFra: Date;
}

export default class KonkurrenceOverblikEksternPresenter extends React.Component<KonkurrenceOverblikEksternPresenterProps, any> {

    constructor(props: KonkurrenceOverblikEksternPresenterProps) {
        super(props);

        this.getOpgaver = this.getOpgaver.bind(this);
        this.wrapOpgaverInRow = this.wrapOpgaverInRow.bind(this);
    }

    wrapOpgaverInRow(opgaver: any, key: number) {
        return (
            <Row key={key} className='opgave-row'>
                {opgaver}
            </Row>
        );
    }    

    getOpgaver() {
        let rows = Array();
        let opgaver = [];
        let i;
        const loggedInRolle = getLoggedInBruger().rolle;
        const erKonkurrenceIdag = erKonkurrenceDag(this.props.konkurrenceDate);
        for (i = 0; i < this.props.opgaver.length; i++) {
            let opgave = this.props.opgaver[i];            
            const kanBedoemme = opgave.opgaveDelopgaverBedoemmesAf.some(d => bedoemmesAfTilRolleMap(d).indexOf(loggedInRolle) !== -1);
            opgaver.push(
                <OpgaveCard
                    key={i}
                    opgave={opgave}
                    konkurrenceId={this.props.konkurrenceId}
                    opgavepakkeOpgaveId={opgave.opgavepakkeOpgaveId}
                    isEnabled={opgave.synlig}
                    showSamletPlacering={false}
                    showResultatButton={erKonkurrenceIdag}
                    kanBedoemme={kanBedoemme}
                    erEkstern={true}
                />
            );

            if (opgaver.length % 3 === 0) {
                rows.push(this.wrapOpgaverInRow(opgaver, i));
                opgaver = Array();
            }
        }
        rows.push(this.wrapOpgaverInRow(opgaver, i++));

        return rows;
    }

    renderOpgaver() {
        const opgaver = this.getOpgaver();

        if (this.props.opgaver.length > 0) {
            return (
                <div className='opgave-overblik'>
                    {opgaver}
                </div>
            );
        } else {
            const formattedDate = moment(this.props.opgaverSynligFra.toString()).format('DD.MM.YY');
            const text = 'Opgaverne er først synlige fra ' + formattedDate;
            return (<Jumbotron title='Opgaver' message={text} icon='warning' />);
        }
    }

    render() {
        const opgavepakkeIds = new Array();
        this.props.opgaver.forEach(o => opgavepakkeIds.push(o.opgavepakkeId));

        return (
            <div>
                <KonkurrenceJumbotron
                    konkurrenceTitel={this.props.konkurrencetitel}
                    konkurrenceDate={this.props.konkurrenceDate}
                    konkurrenceAfviklingssted={this.props.konkurrenceAfviklingssted}
                    samletPlacering={0}
                    konkurrenceId={this.props.konkurrenceId}
                    opgavepakkeNavn=''
                    billedId={this.props.billedId}
                    beskrivelse={this.props.beskrivelse}
                    showSamletPlacering={false}
                    isEkstern={true}
                    opgavepakkeIds={opgavepakkeIds}
                    opgavepakker={this.props.opgavepakker}
                />
                {this.renderOpgaver()}

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/skrivebord/konkurrenceOverblik/KonkurrenceOverblikEksternPresenter.tsx